import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=71682d9e&"
import script from "./fans.vue?vue&type=script&lang=ts&"
export * from "./fans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports